import { Content } from "src/shared/components/content";
import { StyledTitle } from "./styled-components";

/**
 * Title Component for Carousel/List (Dont Miss These Events)
 */
export const DontMissTitleText = ({ variant }) => (
  <StyledTitle>
    {variant === 2 ? (
      // Last Minute Deals
      <Content id="cid$#3221790#" />
    ) : (
      // Last Minute Events
      <Content id="cid$#3113767#" />
    )}
  </StyledTitle>
);
